import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../Styles/login.css";

const API_BASE_URL = "";

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || "Failed to reset password");
      }

      setMessage(data.message || "Password updated successfully.");
      setDone(true);

      // Send them back to login after a short pause
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) {
      setError(err.message || "Failed to reset password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      {/* ---------------- LEFT SIDE ---------------- */}
      <div className="login-left">
        <div className="login-logo">
          <img
            src="/assets/log-VHRD-logo.png"
            alt="Vanakkam HRD Logo"
            className="login-logo-img"
          />
        </div>

        <div className="login-illustration">
          <img src="/assets/log_img.png" alt="Vanakkam HRD" />
        </div>

        <div className="login-left-bottom">
          <h2>Welcome Back!</h2>
          <p>Sign in to your Customer account</p>
        </div>
      </div>

      {/* ---------------- RIGHT SIDE ---------------- */}
      <div className="login-right">
        <form className="login-form" onSubmit={handleSubmit}>
          <h1 className="form-heading">Reset Password</h1>

          <p className="form-subheading">
            {done
              ? "Your password has been updated."
              : "Enter a new password for your admin account."}
          </p>

          {!done && (
            <>
              <label className="form-label">New Password</label>

              <div className="password-field">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-input"
                  placeholder="Enter new password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <img
                  src="/assets/log_eye.png"
                  alt="Toggle password visibility"
                  className="password-eye-icon"
                  onClick={() => setShowPassword((prev) => !prev)}
                />
              </div>

              <label className="form-label">Confirm New Password</label>

              <input
                type={showPassword ? "text" : "password"}
                className="form-input"
                placeholder="Re-enter new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </>
          )}

          {message && <p className="form-success-msg">{message}</p>}
          {error && <p className="form-error-msg">{error}</p>}

          {!done && (
            <button type="submit" className="primary-btn" disabled={loading}>
              {loading ? "UPDATING..." : "Update Password"}
            </button>
          )}
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;